import {btn_c_link, btn_li_md, font_s_lg, panel_light, svg_inline, svg_md, svg_xs, colors, clearfix} from '@xpertdox_js/xdstyle';

export default {
  clearfix: clearfix,
  dashContainer: clearfix,
  dashContent: {
    float: "right",
    width: "100%",
    height: '100%',
    transition: 'width .32s ease-out, padding-left .32s ease-out',
  },
  headerContainer: {
    ...clearfix,
    position: 'fixed',
    zIndex: 40,
    top: 0,
    right: 0,
    left: '60px',
    bottom: 'auto',
    background: '#fff',
    borderBottom: '1px solid rgba(0,0,0,0.12)',
    transition: 'width .12s',
    maxHeight: '45px',
  },
  headerTitle: {
    float: 'left',
    ...font_s_lg,
    fontWeight: 'bold',
    color: colors.xdDarkBlue,
    margin: 0,
    padding: '1rem .8rem 1rem 2rem',
    marginTop: '1px',
  },
  headerRight: {
    float: 'right',
    position: 'relative',
    height: '100%',
    display: 'block',
    background: 'none',
    border: 0,
    cursor: 'pointer',
    padding: '10px 8px',
    marginTop: '1px',
  },
  userIcon: {
    ...svg_md,
    ...svg_inline,
    marginTop: '-3px',
  },
  userName: {
    ...font_s_lg,
    float: 'left',
    marginRight: '.6rem',
  },
  downIcon: {
    ...svg_inline,
    ...svg_xs,
    marginTop: '4px',
  },
  subMenu: {
    ...panel_light,
    position: 'absolute',
    left: 0,
    top: '95%',
    width: '100%',
    borderTop: 0,
  },
  subMenuItem: {
    fontWeight:'normal',
    ...btn_li_md,
    ...btn_c_link.base,
  },
  subMenuItemHov: {
    ...btn_c_link.hover
  }
}
